const tables = [
    {
        name: "Number"
    },
    {
        name: "Name"
    },
    {
        name: "Type"
    },
    {
        name: "Manager"
    },
    {
        name: "Contact"
    },
    {
        name: "Status"
    },
    {
        name: "Action"
    },
];

export default tables;